import { render, staticRenderFns } from "./DomainWhitelistReadOnly.vue?vue&type=template&id=67a19eec&"
import script from "./DomainWhitelistReadOnly.vue?vue&type=script&lang=js&"
export * from "./DomainWhitelistReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports